import { render, staticRenderFns } from "./VPIMain.vue?vue&type=template&id=7ef1924e&scoped=true&"
import script from "./VPIMain.vue?vue&type=script&lang=js&"
export * from "./VPIMain.vue?vue&type=script&lang=js&"
import style0 from "./VPIMain.vue?vue&type=style&index=0&id=7ef1924e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef1924e",
  null
  
)

export default component.exports